import React from 'react';
import logo from '../../assets/construction.png';

import Waitlist from '../Waitlist';
import Merch from '../Merch';
import Wyzant from '../Wyzant';
import Minnect from '../Minnect';

const ComingSoon = ({ showMerch = false, showWyzant = false, showMinnect = false }) => {
  return (
    <div className='flex flex-col items-center py-16 px-4 max-w-3xl mx-auto'>
      <img src={logo} alt='Code Scribes. Software By Master Craftsmen' className='h-40 w-auto mb-8' />
      <h1 className="font-heading text-5xl text-primary-light tracking-tight mb-4">Coming Soon!</h1>
      <p className="font-body text-lg text-neutral-300 text-center leading-relaxed mb-10 max-w-xl">
        Thanks for checking out this initiative. We're currently working hard to make this dream become a reality.
        There's a couple things you can do to help us out though! Checkout the ways to connect with us and help support our cause below.
      </p>
      <div className='flex flex-col gap-8 w-full'>
        { showMerch ? (<Merch />) : null}
        { showWyzant ? (<Wyzant />) : null }
        { showMinnect ? (<Minnect />) : null }
        <Waitlist />
      </div>
    </div>
  );
};

export default ComingSoon;
